import { isDataLayersArtificialBoundaryTerritoryGroup } from '~/sidebar/sidebarApps/mapTools/dataLayersTool/dataLayersTool.helpers';
import type { BoundaryTerritoryGroup } from './boundaryTerritoryGroups.state';

export const isArtificialBoundaryTerritoryGroup = (btg: BoundaryTerritoryGroup) => {
  return btg.boundaryTerritoryGroupId <= 0 || isDataLayersArtificialBoundaryTerritoryGroup(btg);
};

export const ensureBeValidBoundaryTerritoryGroupId = (btg: BoundaryTerritoryGroup) => {
  if (isArtificialBoundaryTerritoryGroup(btg)) {
    return undefined;
  }
  else {
    return btg.boundaryTerritoryGroupId;
  }
};
